import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import IndustryDetailPage from "@/pages/IndustryDetail";

export const Route = createFileRoute("/$lang/industrias/$slug")({
  head: ({ params }) => pageHead(params.lang, "industry", params.slug),
  component: IndustryDetailPage,
});
